var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.333v-.762C5.5 4.04 7.507 2 10 2s4.5 2.039 4.5 4.571v.762m-9 0c-.825 0-1.5.686-1.5 1.524v7.62C4 17.313 4.675 18 5.5 18h9c.825 0 1.5-.686 1.5-1.524V8.857c0-.838-.675-1.524-1.5-1.524m-9 0h9m-4.5 3.81c.825 0 1.5.686 1.5 1.524s-.675 1.524-1.5 1.524-1.5-.686-1.5-1.524.675-1.524 1.5-1.524Z",
    stroke: "#002FF1",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSecurityIcon);
export default __webpack_public_path__ + "static/media/profile-security-icon.61aea025d22ccd73ef533055c66650e9.svg";
export { ForwardRef as ReactComponent };